// @flow

import WindowScroller, {IS_SCROLLING_TIMEOUT} from './WindowScroller';

export default WindowScroller;
export {WindowScroller, IS_SCROLLING_TIMEOUT};
